module.exports = __webpack_public_path__ + "img/jxk_shjd.3f469dc6.svg";